<template>
  <v-select
    :label="$attrs.label || propLabel"
    v-bind="$attrs"
    filled
    :item-text="$attrs['item-text'] || 'DisplayText'"
    :item-value="$attrs['item-value'] || 'ID'"
    v-on="$listeners"
  >
    <template #append>
      <v-icon
        v-if="model && model.__proxy__ && model.__proxy__.isDirty(def.name)"
        @click="model && model.__proxy__ && model.__proxy__.undo(def.name)"
      >
        mdi-undo
      </v-icon>
    </template>
    <template #prepend-inner>
      <AppToolTip v-if="def && def.help" :def="def.help"></AppToolTip>
    </template>
    <template #label>
      <div>
        {{ propLabel
        }}<span
          v-if="def && def.kind === 'TFormProp' && def.required"
          class="red--text font-weight-bold"
        >
          *</span
        >
      </div>
    </template>
  </v-select>
</template>

<script>
import AppToolTip from "@/components/library/common/AppToolTip";
export default {
  name: "AppSelectBox",
  components: { AppToolTip },
  props: ["def", "model"],
  
  computed: {
    propLabel() {
      let label = this.$t(this.def);
      return label;
    },
  },

  created(){
    if(this.$attrs.multiple && ! Array.isArray(this.model[this.def.name]))
      this.$set(this.model , this.def.name , JSON.parse(this.model[this.def.name]))
  },
};
</script>
